export const stampedUrl = page =>
  `https://stamped.io/api/widget/reviews?apiKey=pubkey-39xaK3C77F8i33x6hAy4S71ZpR2a6J&storeUrl=nilsgroen.myshopify.com&productId=4460550193283&take=3&page=${page}`;

export const countryFlagsUrl = country =>
  `https://www.countryflags.io/${country}/flat/64.png`;

export const stampedImageUrl = photo =>
  `https://cdn.stamped.io/uploads/photos/thumb/${photo}`;
